'use client';

import {
  ArticleCard,
  AuthorByline,
  CardDate,
  Eyebrow,
  Image,
  Title,
} from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import { useHideDateStamp } from '@/app_lib/hooks/useHideDateStamp';
import { useContentCardTrackingData } from '@/app_lib/services/contentCardTracking';
import { getExtendedArticle } from '@/app_lib/services/contentCardTracking/utils';
import type { ArticlePreviewMostPopular } from '@/app_lib/types/ArticlePreview';
import type { ModuleType } from '@/app_lib/types/ContentCardTracking';

export const ArticleCardRailFull = ({
  article,
  className,
  index = 1,
  moduleType = 'rail_full',
  priority,
  hideDateStamp = false,
}: {
  article: ArticlePreviewMostPopular;
  className?: string;
  index?: number;
  moduleType?: ModuleType;
  priority?: boolean;
  hideDateStamp?: boolean;
}) => {
  const generateContentCardTrackingData = useContentCardTrackingData();
  const hideDateFromExperiment = useHideDateStamp();
  const hideDate = hideDateStamp || hideDateFromExperiment;

  return (
    <ArticleCard
      className={className}
      variant='railFull'
    >
      <Eyebrow
        contentCardTrackingData={generateContentCardTrackingData({
          article: getExtendedArticle(article),
          cardPosition: index,
          clickTarget: 'eyebrow',
          moduleType,
        })}
        sectionName={article.sectionName}
        sectionUrl={article.sectionUrl}
      />
      <div className='flex flex-col gap-md md:gap-0 xl:gap-md'>
        <div className='flex gap-md md:gap-lg xl:gap-md'>
          <Title
            contentCardTrackingData={generateContentCardTrackingData({
              article: getExtendedArticle(article),
              cardPosition: index,
              clickTarget: 'headline',
              moduleType,
            })}
            title={article.title}
            url={article.url}
            variant='railFull'
          />
          <Image
            contentCardTrackingData={generateContentCardTrackingData({
              article: getExtendedArticle(article),
              cardPosition: index,
              clickTarget: 'image',
              moduleType,
            })}
            image={article.image}
            imageAlt={article.imageAlt?.trim() || article.title}
            priority={priority}
            url={article.url}
            variant='railFull'
          />
        </div>
        <div className='flex flex-col'>
          <AuthorByline
            authors={article.authors}
            contentCardTrackingData={generateContentCardTrackingData({
              article: getExtendedArticle(article),
              cardPosition: index,
              clickTarget: 'author',
              moduleType,
            })}
            variant='railFull'
          />
          <CardDate
            dateGmt={article.dateGmt}
            hidden={hideDate}
            variant='railFull'
          />
        </div>
      </div>
    </ArticleCard>
  );
};
